import { render, staticRenderFns } from "./DefectDetail.vue?vue&type=template&id=08f15c46"
import script from "./DefectDetail.vue?vue&type=script&lang=js"
export * from "./DefectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports